import React from 'react';
import Image from 'next/image';
import classNames from 'classnames';

import { Gps, Internet, Phone } from '@/icons/business/products';
import { Facebook, Instagram, Whatsapp } from '@/icons/social/light';
import { ArrowRight } from '@/icons/index';

import Tabs from '../Tabs/Tabs';
import TabPanel from '../Tabs/TabPanel';
import Tab from '../Tabs/Tab';
import Button from '../Button/Button';

import styles from './BusinessLargeProduct.module.scss';

const BusinessLargeProduct = ({ data, onApply }) => {
  const [state, setState] = React.useState({
    memory: data?.memorySize[0],
    month: data?.availableMonth[0],
    currentImg: data?.availableColors[0],
  });

  const onClick = () => {
    onApply(state);
  };

  const renderColor = (item, index) => {
    const changeProduct = () => {
      setState({
        ...state,
        currentImg: item,
      });
    };
    return (
      <button
        key={index}
        className={classNames([
          styles.color,
          { [styles.active]: item.id === state.currentImg.id },
        ])}
        onClick={changeProduct}
        aria-label='Bakcell'
        itemScope
        itemType='https://schema.org/Offer'
      >
        <Image src={item.src} layout={'fill'} alt='img' loading='lazy' />
      </button>
    );
  };

  const renderMemorySizeItem = (item, index) => {
    const changeMemorySize = () => {
      setState({
        ...state,
        memory: item,
      });
    };

    return (
      <Tab
        className={styles.tab}
        active={item.id === state.memory.id}
        onClick={changeMemorySize}
        key={index}
        itemScope
        itemType='https://schema.org/Text'
      >
        {item.name}
      </Tab>
    );
  };

  const renderAvailableMonthItem = (item, index) => {
    const changeAvailableMonth = () => {
      setState({
        ...state,
        month: item,
      });
    };

    return (
      <Tab
        className={styles.tab}
        active={item.id === state.month.id}
        onClick={changeAvailableMonth}
        key={index}
        itemScope
        itemType='https://schema.org/Text'
      >
        {item.name}
      </Tab>
    );
  };

  return (
    <div
      className={styles.item}
      itemScope
      itemType='https://schema.org/Product'
    >
      <div className={styles.left}>
        <div className={styles.title}>
          Apple iPhone 13 Pro Max 128GB Graphite
        </div>
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            src={state.currentImg.img}
            layout={'fill'}
            alt='img'
            loading='lazy'
          />
        </div>
        {data?.availableColors && (
          <div className={styles.colors}>
            {data.availableColors.map(renderColor)}
          </div>
        )}
        {data?.memorySize && (
          <Tabs>
            <TabPanel className={styles.tabPanel}>
              {data.memorySize.map(renderMemorySizeItem)}
            </TabPanel>
          </Tabs>
        )}
      </div>
      <div className={styles.right}>
        <div className={styles.top}>
          {data?.internet && (
            <div className={styles.item}>
              <div>
                <Internet />
              </div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <span className={styles.title}>{data.internet?.title1}</span>
                  <div className={styles.desc}>{data.internet?.value1}</div>
                </div>
                <div className={styles.content}>
                  <span className={styles.title}>{data.internet?.title2}</span>
                  <div className={styles.desc}>{data.internet?.value2}</div>
                </div>
              </div>
            </div>
          )}
          {data?.calls && (
            <div className={styles.item}>
              <div>
                <Phone />
              </div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <span className={styles.title}>{data.calls?.title1}</span>
                  <div className={styles.desc}>{data.calls?.value1}</div>
                </div>
                <div className={styles.content}>
                  <span className={styles.title}>{data.calls?.title2}</span>
                  <div className={styles.desc}>{data.calls?.value2}</div>
                </div>
              </div>
            </div>
          )}
          {data?.gps && (
            <div className={styles.item}>
              <div>
                <Gps />
              </div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <span className={styles.title}>{data.gps?.title1}</span>
                  <div className={styles.desc}>{data.gps?.value1}</div>
                </div>
                <div className={styles.content}>
                  <span className={styles.title}>{data.gps?.title2}</span>
                  <div className={styles.desc}>{data.gps?.value2}</div>
                </div>
              </div>
            </div>
          )}
          {data?.chat && (
            <div className={styles.item}>
              <div>{/* <Chat /> */}</div>
              <div className={styles.wrapper}>
                <div className={styles.content}>
                  <span className={styles.title}>{data.chat?.title1}</span>
                  <div className={styles.desc}>{data.chat?.value1}</div>
                </div>
                {data.chat?.social && (
                  <div className={styles.content}>
                    <span className={styles.title}>
                      {data.chat.social?.title}
                    </span>
                    <div className={styles.desc}>
                      <span className={styles.icons}>
                        {data.chat.social?.instagram && <Instagram />}
                        {data.chat.social?.whatsapp && <Whatsapp />}
                        {data.chat.social?.facebook && <Facebook />}
                      </span>
                      {data.chat.social?.text}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className={styles.bottom}>
          {data?.availableMonth && (
            <Tabs>
              <TabPanel className={styles.tabPanel}>
                {data.availableMonth.map(renderAvailableMonthItem)}
              </TabPanel>
            </Tabs>
          )}
          <div className={styles.total}>
            2 135 ₼ <span>| month</span>
          </div>
          <Button className={styles.button} onClick={onClick}>
            Buy now <ArrowRight width={22} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BusinessLargeProduct;
